import { ReactNode } from "react";


export interface ISidbarProps
{
    active: string;
    onMenuClick: () => void;
    menuPosition: MENUPOSITION;
    openSubMenu?: string | null;
    setOpenSubMenu?: React.Dispatch<React.SetStateAction<string | null>>
    leftmenu?:boolean
}

export interface IUserConfig
{
    role: number;
}


export enum MENUPOSITION
{
    VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL'
}